import { render, staticRenderFns } from "./LoaderOverlay.vue?vue&type=template&id=513cf152&scoped=true&"
import script from "./LoaderOverlay.vue?vue&type=script&lang=js&"
export * from "./LoaderOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../applauncher/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513cf152",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../applauncher/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
